import * as React from "react";
import { useStaticQuery, graphql } from 'gatsby';
import { Box, Button, Container, Typography } from "@mui/material";

import Slider from 'components/Slider';
import SliderArrows from 'components/SliderArrows';
import ZBox from 'components/ZBox';
import ExpandableCard from 'components/Cards/ExpandableCard';
import useLiveData from 'hooks/useLiveData';
import theme, { getColor } from 'utils/theme';

const ServiceListSlider = props => {
	const { title, link, linkText, blacklist } = props;

	const disallow = typeof blacklist === 'string' ? [blacklist] : blacklist || [];

	const arrowRef = React.useRef([null, null]);
	const [initialize, setInitialize] = React.useState(false);

	React.useEffect(() => {
		setInitialize(true);
	},[]);
	
	const data = useStaticQuery(graphql`
		query serviceListSlider {
		  allDepartment(
			filter: {approved: {eq: true}, archived: {eq: false}, deleted: {eq: false}, inListing: {eq: true}}
		  ) {
		      edges {
				node {
					id
					name
					description
					icon
					uri
				}
			  }
		  }
		}
	`);

	const { edges } = data.allDepartment;
	const nodes = edges.map(({ node }) => node);

	const { statusText: providerStatusText, status: providerStatus, response: providerResponse, visibilityChange } = useLiveData({
		type: 'Department',
		apiParams: {
			approved: true,
			deleted: false,
			archived: false,
			inListing: true,
			_exclude: 'Industry,Post',
			_include: 'name,description,icon,uri',
			_sort: { fields: ["sort"], order: "desc" },
			'!id': disallow,
		},
		staticData: data,
	});

	let services = nodes;
	if (((providerResponse && providerResponse.data.length > 0) || services.length > 0) && providerStatusText === 'LOADED') {
		services = providerResponse.data;
	}
	if (providerResponse && visibilityChange) services = providerResponse.data;
	if (services.length === 0 && providerStatus >= 2) return null;

	if (disallow.length) services = services.filter(service => !disallow.includes(service.id));

	const sectionStyle = {
		backgroundColor: getColor('blue', 500),
		padding: '81px 0 73px',
		overflow: 'hidden',
	};

	const sliderParams = {
		loop: true,
		slidesPerView: '1.1',
		spaceBetween: 20,
		pagination: false,
		navigation: {
			prevEl: arrowRef.current[0],
			nextEl: arrowRef.current[1],
		},
		injectStyles: [
			`
			.swiper {
				overflow: visible;
			}
			::slotted(swiper-slide) {
				height: auto !important;
				display: flex;
			}
			`
		],
		breakpoints: {
			[theme.breakpoints.values.laptop]: {
				loop: false,
				slidesPerView: 2,
				spaceBetween: 20,
			}
		},
	};

	return (
		<Box sx={sectionStyle} component={"section"}>
			<Container>
				<ZBox className={'slider__title_holder'} sx={{ marginBottom: "38px" }}>
					<Typography variant={"h1"} component={"h2"}>{title}</Typography>
					<SliderArrows refFunction={arrowRef} />
				</ZBox>
				<Slider params={sliderParams} initialize={initialize}>
					{services.map((service, index) => (
						<swiper-slide key={`service-${index}-${service.id}`}>
							<ExpandableCard equalize={false} fullWidth={true} title={service.name} body={service.description} link={service.uri} icon={service.icon} />
						</swiper-slide>
					))}
				</Slider>
				{link && <Box sx={{ textAlign: "center", marginTop: "55px" }}><Button variant="outlined" color="white" href={link}>{linkText}</Button></Box>}
			</Container>
		</Box>
	)
}

export { Head } from 'components/Head';

export default ServiceListSlider;